import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

export interface IRadioButtons {
  buttons: { value: (number | boolean | string), label: string, id?: number| string }[];
  groupName: string;
}

@Component({
  selector: 'app-radio-button-group',
  templateUrl: './radio-button-group.component.html',
  styleUrls: ['./radio-button-group.component.scss']
})
export class RadioButtonGroupComponent implements OnInit {

  @Input() fadedButtons = false;
  @Input() buttonValues: IRadioButtons;
  @Input() selectedValue: number | boolean | string;
  @Input() showError: boolean;
  @Output() buttonClicked: EventEmitter<number | boolean | string> = new EventEmitter<number | boolean | string>();

  constructor() {
  }

  ngOnInit(): void {
  }

  setValue(value: number | boolean | string): void {
    this.buttonClicked.emit(value);
    this.selectedValue = value;
  }

}
